import { JournalDtoTopic } from '../api/generated/model';

export function getJournalTopicName(topic: JournalDtoTopic) {
  switch (topic) {
    case JournalDtoTopic.NONE:
      return 'Anderes';
    case JournalDtoTopic.CONTACT_TRACING:
      return 'Contact-Tracing';
    case JournalDtoTopic.ANAMNESIS:
      return 'Anamnese';
    case JournalDtoTopic.THERAPY:
      return 'Therapie';
    case JournalDtoTopic.DIAGNOSTICS:
      return 'Diagnostik';
    case JournalDtoTopic.PERSONAL_DETAILS:
      return 'Personalien';
    case JournalDtoTopic.NETWORK:
      return 'Netzwerk';
    case JournalDtoTopic.TRACING_CONTACT:
      return 'Kontaktperson';
    case JournalDtoTopic.SCREENING_PERSON:
      return 'Screeningperson';
  }
}
